import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import EmailIcon from "@mui/icons-material/Email";
import toast from "react-hot-toast";
import { loginUser } from "../../../api/login";
import { setToken, setUser, clearStorage } from "../../../utils/Storage";

const Login = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!username || !password) {
      toast.error("Please fill all fields");
      return;
    }

    setLoading(true);

    try {
      const res = await loginUser({
        username: username.trim(),
        password: password.trim(),
      });

      const data = res?.data;

      if (data?.token) {
        setToken(data.token);
        setUser(data.user || {});
        localStorage.setItem("role", data.user.role);

        toast.success("Login Successful 🎉");

        const role = data.user?.role;

        if (role === "superadmin" || role === "admin") {
          navigate("/admin/dashboard");
        } else {
          navigate("/employee/dashboard");
        }
      }
    } catch (error) {
      // ✅ Clear old session (important)
      clearStorage();

      const msg = error.response?.data?.message;

      if (msg === "Invalid username or password") {
        toast.error("Please enter correct username/password");
      } else {
        toast.error(msg || "Login failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="login-page">
      <div className="login-right">
        <div className="login-card">
          <h2 className="py-1">Welcome to Red Cloud</h2>
          <p className="subtitle py-1">Login to your account</p>

          <div className="input-box py-3">
            <EmailIcon className="icon" />
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={loading}
            />
          </div>

          <div className="input-box">
            <LockIcon className="icon" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={loading}
            />
            <span
              className="eye"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </span>
          </div>

          <div className="forgot" onClick={() => navigate("/forget")}>
            Forgot Password?
          </div>

          <button
            className="login-btn"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>

          <p className="register-text py-3">
            New Employee?{" "}
            <span onClick={() => navigate("/register")}>
              Register Here
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;